import { Configuration } from "./shared/interfaces";

const configElement: Configuration = {
  baseApiUrl: process.env.REACT_APP_API_ENDPOINT || "http://localhost:4000/api/v1/",
  baseWSUrl: process.env.REACT_APP_WS_ENDPOINT || "http://localhost:4000/",
};

export default configElement;
